export const KEYS = {
  ACCESS_TOKEN_COOKIE: "access_token_cookie",
  REFRESH_TOKEN_COOKIE: "refresh_token_cookie",
};
